import { render, staticRenderFns } from "./StudentEditor.vue?vue&type=template&id=5649da67&"
import script from "./StudentEditor.vue?vue&type=script&lang=js&"
export * from "./StudentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports